// extracted by mini-css-extract-plugin
export default {"wrap":"uG-z"};